export const CHANGE_ACCORDION = 'CHANGE_ACCORDION';
export const CHANGE_TO_NEXT_ACCORDION = 'CHANGE_TO_NEXT_ACCORDION';
export const GET_CHECKOUT_SECTIONS_INFO = 'GET_CHECKOUT_SECTIONS_INFO';
export const GET_PROFILE_INFO = 'GET_PROFILE_INFO';
export const INIT_NEW_CHECKOUT_SECTIONS = 'INIT_NEW_CHECKOUT_SECTIONS';
export const INIT_NEW_CHECKOUT_SECTIONS_CLIENT_SIDE_ACTIONS =
    'INIT_NEW_CHECKOUT_SECTIONS_CLIENT_SIDE_ACTIONS';
export const IS_MOUNT_ON_SERVER = 'IS_MOUNT_ON_SERVER';
export const SET_CREATE_ACCOUNT_MESSAGE = 'SET_CREATE_ACCOUNT_SUCCESS_MESSAGE';
export const SET_PROFILE_INFO = 'SET_PROFILE_INFO';
export const VALIDATE_SHIPPING = 'VALIDATE_SHIPPING';
export const GET_PROMOTIONAL_EMAIL_SECTION = 'GET_PROMOTIONAL_EMAIL_SECTION';
